import { render } from "./DesignVersionRail.vue?vue&type=template&id=122fb722&scoped=true"
import script from "./DesignVersionRail.vue?vue&type=script&lang=js"
export * from "./DesignVersionRail.vue?vue&type=script&lang=js"

import "./DesignVersionRail.vue?vue&type=style&index=0&id=122fb722&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122fb722"]])

export default __exports__